import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpService } from 'src/app/services/http-service.service';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-aviso-de-privacidad',
  templateUrl: './aviso-de-privacidad.component.html',
  styleUrls: ['./aviso-de-privacidad.component.scss'],
})
export class AvisoDePrivacidadComponent implements OnInit, OnDestroy {
  html = '';

  private languageSub?: Subscription;

  constructor(
    private readonly http: HttpService,
    private readonly languageService: LanguageService,
  ) {}

  ngOnInit(): void {
    this.languageSub = this.languageService.currentLanguage$.subscribe(() => {
      this.loadContent();
    });
  }

  ngOnDestroy(): void {
    this.languageSub?.unsubscribe();
  }

  private loadContent(): void {
    this.http.getAvisoDePrivacidad().subscribe((response: any) => {
      this.html = response.body;
    });
  }
}
